import debounce from "lodash.debounce";
import { useRouter } from "next/router";
import { CSSProperties, useCallback, useEffect, useState } from "react";
import { BsStar, BsStarFill } from "react-icons/bs";
import { API } from "../../services/api/types";
import { useAuth } from "../../utils/AuthContext";
import { isFavorite } from "../../utils/favorites";

type FavoriteToggleProps = {
  type: string;
  favorite: API.Favorite;
  style?: CSSProperties;
};

const FavoriteToggle = ({ type, favorite, style }: FavoriteToggleProps) => {
  const { favorites, toggleFavorite, isAuthenticated } = useAuth();
  const router = useRouter();

  const hasFavorite = favorites
    ? isFavorite(type, favorite.id, favorites)
    : false;
  const [isActive, setIsActive] = useState(hasFavorite);

  useEffect(() => {
    setIsActive(hasFavorite);
  }, [hasFavorite]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const onClickDebounced = useCallback(
    debounce(() => toggleFavorite(type, favorite), 400),
    [type, favorite, toggleFavorite]
  );

  if (isActive) {
    return (
      <BsStarFill
        className="cursor-pointer flex-shrink-0"
        onClick={(e) => {
          e.preventDefault();

          if (!isAuthenticated) {
            return router.push("/logga-in");
          }

          setIsActive(false);
          onClickDebounced();
        }}
        style={{
          width: 14,
          height: 14,
          ...style,
        }}
      />
    );
  }

  return (
    <BsStar
      className="cursor-pointer flex-shrink-0"
      onClick={(e) => {
        e.preventDefault();

        if (!isAuthenticated) {
          return router.push("/logga-in");
        }

        setIsActive(true);
        onClickDebounced();
      }}
      style={{
        width: 14,
        height: 14,
        ...style,
      }}
    />
  );
};

export default FavoriteToggle;
